import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Lock, Trash2, X } from 'lucide-react';
import { useVehicles } from '../contexts/VehiclesContext';
import { ANIOS, COMBUSTIBLES, MARCAS } from '../types/vehicle';
import type { VehicleEstado } from '../types/vehicle';
const PASSWORD = 'flashgo2026';
const fieldClass = 'w-full bg-[#1a1a1a] border border-brand-white/10 rounded p-3 text-brand-white text-sm focus:border-brand-gold outline-none transition-colors';
const labelClass = 'block text-sm text-brand-white/70 mb-1';
const emptyForm = {
  marca: MARCAS[0],
  modelo: '',
  anio: ANIOS[0],
  combustible: COMBUSTIBLES[0],
  km: '',
  color: '',
  precioArs: '',
  precioUsd: '',
  estado: 'Disponible' as VehicleEstado,
  equipamiento: ''
};
export function AdminPanel() {
  const {
    isAdminOpen,
    closeAdmin,
    addVehicle,
    vehicles,
    removeVehicle
  } = useVehicles();
  const [password, setPassword] = useState('');
  const [unlocked, setUnlocked] = useState(false);
  const [error, setError] = useState('');
  const [form, setForm] = useState(emptyForm);
  const [fotos, setFotos] = useState<string[]>([]);
  const [saved, setSaved] = useState(false);
  const handleUnlock = (e: React.FormEvent) => {
    e.preventDefault();
    if (password === PASSWORD) {
      setUnlocked(true);
      setError('');
    } else {
      setError('Contraseña incorrecta');
    }
  };
  const handleFiles = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files ?? []).slice(0, 10);
    Promise.all(files.map(file => new Promise<string>(resolve => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result));
      reader.readAsDataURL(file);
    }))).then(setFotos);
  };
  const handleSave = (e: React.FormEvent) => {
    e.preventDefault();
    addVehicle({
      ...form,
      fotos
    });
    setForm(emptyForm);
    setFotos([]);
    setSaved(true);
    window.setTimeout(() => setSaved(false), 2500);
  };
  const handleClose = () => {
    closeAdmin();
    setPassword('');
    setError('');
  };
  return <AnimatePresence data-id="element-6" data-mp="2vnymeobq8x44">
      {isAdminOpen && <>
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} onClick={handleClose} className="fixed inset-0 z-[60] bg-black/70" data-id="element-7" data-mp="30fztzwxy9znt" />
          <motion.aside initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        duration: 0.28,
        ease: [0.23, 1, 0.32, 1]
      }} role="dialog" aria-label="Panel de administración de stock" className="fixed top-0 right-0 bottom-0 z-[70] w-full max-w-md bg-brand-black border-l border-brand-gold/30 overflow-y-auto" data-id="element-8" data-mp="2cpvrxu0eu7yx">
            <header className="sticky top-0 bg-brand-black/95 backdrop-blur-sm border-b border-brand-gold/20 px-6 py-5 flex items-center justify-between" data-id="element-9" data-mp="1x2njs961idf">
              <h2 className="font-heading text-2xl text-brand-gold" data-id="element-10" data-mp="1hhtq4eahqjk0">
                Panel de stock
              </h2>
              <button type="button" onClick={handleClose} aria-label="Cerrar panel" className="text-brand-white/60 hover:text-brand-white transition-colors" data-id="element-11" data-mp="1cq3i4ez107vr">
                <X className="w-5 h-5" data-id="element-12" data-mp="12u0awupbhj1y" />
              </button>
            </header>

            <div className="px-6 py-6" data-id="element-13" data-mp="ypiw79xtdvy1">
              {!unlocked ? <form onSubmit={handleUnlock} className="space-y-4" data-id="element-14" data-mp="tr7nj2j99rhe">
                  <div className="w-12 h-12 rounded-full bg-brand-gold/10 flex items-center justify-center" data-id="element-15" data-mp="oswe2swvhizp">
                    <Lock className="w-5 h-5 text-brand-gold" data-id="element-16" data-mp="2o5s536ca56wk" />
                  </div>
                  <p className="text-brand-white/70 text-sm" data-id="element-17" data-mp="2j6xj5vj0n288">
                    Ingresá la contraseña para administrar el stock.
                  </p>
                  <div data-id="element-18" data-mp="1gu11m1lzr424">
                    <label htmlFor="admin-pass" className={labelClass} data-id="element-19" data-mp="1greshxjgcghs">
                      Contraseña
                    </label>
                    <input id="admin-pass" type="password" value={password} onChange={e => setPassword(e.target.value)} className={fieldClass} autoComplete="current-password" data-id="element-20" data-mp="16vv0vnbx83yu" />
                  </div>
                  {error && <p className="text-red-400 text-sm" data-id="element-21" data-mp="11yd2urzfz95m">{error}</p>}
                  <button type="submit" className="w-full py-3 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors" data-id="element-22" data-mp="o656v2fzfm7z">
                    Ingresar
                  </button>
                </form> : <>
                  <form onSubmit={handleSave} className="space-y-4" data-id="element-23" data-mp="j7va4nem0dk9">
                    <div className="grid grid-cols-2 gap-4" data-id="element-24" data-mp="3vq4t8hrcqjhh">
                      <div data-id="element-25" data-mp="3ro1gzqwuzav5">
                        <label htmlFor="adm-marca" className={labelClass} data-id="element-26" data-mp="3rot7inblmiek">
                          Marca
                        </label>
                        <select id="adm-marca" value={form.marca} onChange={e => setForm({
                    ...form,
                    marca: e.target.value
                  })} className={fieldClass} data-id="element-27" data-mp="9g29o5o0ho0h">
                          {MARCAS.map(m => <option key={m} data-id="element-28" data-mp="s7uyrozymp2x">{m}</option>)}
                        </select>
                      </div>
                      <div data-id="element-29" data-mp="126kh1ivrqbjp">
                        <label htmlFor="adm-modelo" className={labelClass} data-id="element-30" data-mp="127vjnfdh9d98">
                          Modelo
                        </label>
                        <input id="adm-modelo" required type="text" value={form.modelo} onChange={e => setForm({
                    ...form,
                    modelo: e.target.value
                  })} className={fieldClass} data-id="element-31" data-mp="x5whu9xdyoee" />
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4" data-id="element-32" data-mp="1ny53glw2yma7">
                      <div data-id="element-33" data-mp="1s08jlntp2f1t">
                        <label htmlFor="adm-anio" className={labelClass} data-id="element-34" data-mp="1rzgsap74r3hc">
                          Año
                        </label>
                        <select id="adm-anio" value={form.anio} onChange={e => setForm({
                    ...form,
                    anio: e.target.value
                  })} className={fieldClass} data-id="element-35" data-mp="1wxibrb8gx4tc">
                          {ANIOS.map(a => <option key={a} data-id="element-36" data-mp="2p71epxqeec">{a}</option>)}
                        </select>
                      </div>
                      <div data-id="element-37" data-mp="3mggxmmrk1053">
                        <label htmlFor="adm-km" className={labelClass} data-id="element-38" data-mp="3mhs1snoww9wq">
                          Kilometraje
                        </label>
                        <input id="adm-km" type="number" min="0" value={form.km} onChange={e => setForm({
                    ...form,
                    km: e.target.value
                  })} className={fieldClass} data-id="element-39" data-mp="3hfj79mwe4zsi" />
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4" data-id="element-40" data-mp="2tt4aobhheqb9">
                      <div data-id="element-41" data-mp="2osydygwcudmb">
                        <label htmlFor="adm-comb" className={labelClass} data-id="element-42" data-mp="2osoy3m50xmuc">
                          Combustible
                        </label>
                        <select id="adm-comb" value={form.combustible} onChange={e => setForm({
                    ...form,
                    combustible: e.target.value
                  })} className={fieldClass} data-id="element-43" data-mp="3efstlpo656e9">
                          {COMBUSTIBLES.map(c => <option key={c} data-id="element-44" data-mp="14ai7ksrj278">{c}</option>)}
                        </select>
                      </div>
                      <div data-id="element-45" data-mp="3oftehg1orukk">
                        <label htmlFor="adm-color" className={labelClass} data-id="element-46" data-mp="3oeib3hc5kotz">
                          Color
                        </label>
                        <input id="adm-color" type="text" value={form.color} onChange={e => setForm({
                    ...form,
                    color: e.target.value
                  })} className={fieldClass} data-id="element-47" data-mp="3seiocynimtzg" />
                      </div>
                    </div>

                    <div className="grid grid-cols-2 gap-4" data-id="element-48" data-mp="2j8jrws2pd98i">
                      <div data-id="element-49" data-mp="2ja368d4sta7n">
                        <label htmlFor="adm-ars" className={labelClass} data-id="element-50" data-mp="2e9786g74oia5">
                          Precio ARS
                        </label>
                        <input id="adm-ars" required type="number" min="0" value={form.precioArs} onChange={e => setForm({
                    ...form,
                    precioArs: e.target.value
                  })} className={fieldClass} data-id="element-51" data-mp="1qk4hyjyfhh41" />
                      </div>
                      <div data-id="element-52" data-mp="36ye211vn0jp2">
                        <label htmlFor="adm-usd" className={labelClass} data-id="element-53" data-mp="36x2xv0ya59xf">
                          Precio USD (opcional)
                        </label>
                        <input id="adm-usd" type="number" min="0" value={form.precioUsd} onChange={e => setForm({
                    ...form,
                    precioUsd: e.target.value
                  })} className={fieldClass} data-id="element-54" data-mp="1oxb6cm2hcqhv" />
                      </div>
                    </div>

                    <div data-id="element-55" data-mp="169pqrd22gq5j">
                      <span className={labelClass} data-id="element-56" data-mp="1180ghzmo4gii">Estado</span>
                      <div className="flex gap-4" data-id="element-57" data-mp="11acszx9npyo6">
                        {(['Disponible', 'Vendido'] as VehicleEstado[]).map(opt => <label key={opt} className="flex items-center gap-2 text-brand-white text-sm cursor-pointer" data-id="element-58" data-mp="2vkymw858yt0k">
                              <input type="radio" name="adm-estado" value={opt} checked={form.estado === opt} onChange={() => setForm({
                      ...form,
                      estado: opt
                    })} className="accent-brand-gold" data-id="element-59" data-mp="2y66av9suugaz" />
                              {opt}
                            </label>)}
                      </div>
                    </div>

                    <div data-id="element-60" data-mp="2u5nk7j2p7gad">
                      <label htmlFor="adm-fotos" className={labelClass} data-id="element-61" data-mp="2u5vtz23iy5hc">
                        Fotos (máx. 10)
                      </label>
                      <input id="adm-fotos" type="file" accept="image/*" multiple onChange={handleFiles} className="w-full text-sm text-brand-white/70 file:mr-3 file:py-2 file:px-4 file:rounded file:border-0 file:bg-brand-gold file:text-brand-black file:font-bold file:text-sm" data-id="element-62" data-mp="4i52omzwhim5" />
                      {fotos.length > 0 && <p className="text-brand-gold text-xs mt-2" data-id="element-63" data-mp="2afa3igpbrqap">
                          {fotos.length} foto{fotos.length === 1 ? '' : 's'}{' '}
                          cargada{fotos.length === 1 ? '' : 's'}
                        </p>}
                    </div>

                    <div data-id="element-64" data-mp="1vlyit95exllz">
                      <label htmlFor="adm-equip" className={labelClass} data-id="element-65" data-mp="1qtdpe8qf5aiz">
                        Equipamiento
                      </label>
                      <textarea id="adm-equip" rows={3} value={form.equipamiento} onChange={e => setForm({
                  ...form,
                  equipamiento: e.target.value
                })} className={fieldClass} data-id="element-66" data-mp="1328apww7soa9" />
                    </div>

                    <button type="submit" className="w-full py-3.5 bg-brand-gold text-brand-black font-bold rounded hover:bg-brand-white transition-colors" data-id="element-67" data-mp="f161a4pwk4hu">
                      Guardar vehículo
                    </button>
                    {saved && <p className="text-brand-gold text-sm text-center" data-id="element-68" data-mp="1cmtwimamggrs">
                        Vehículo guardado y publicado en el stock.
                      </p>}
                  </form>

                  {vehicles.length > 0 && <div className="mt-10 border-t border-brand-white/10 pt-6" data-id="element-69" data-mp="3igada1367v9n">
                      <h3 className="text-brand-white font-bold text-sm mb-4" data-id="element-70" data-mp="3nfekim6jbixc">
                        Publicados ({vehicles.length})
                      </h3>
                      <ul className="space-y-2" data-id="element-71" data-mp="7jhwi1u52lap">
                        {vehicles.map(v => <li key={v.id} className="flex items-center justify-between gap-3 bg-[#151515] rounded px-3 py-2" data-id="element-72" data-mp="2olrm13t03g6">
                            <span className="text-brand-white/80 text-sm truncate" data-id="element-73" data-mp="3ow25kj3tcthl">
                              {v.marca} {v.modelo} · {v.anio}
                            </span>
                            <button type="button" onClick={() => removeVehicle(v.id)} aria-label={`Eliminar ${v.marca} ${v.modelo}`} className="text-brand-white/40 hover:text-red-400 transition-colors shrink-0" data-id="element-74" data-mp="lhy19n8fy1q7">
                              <Trash2 className="w-4 h-4" data-id="element-75" data-mp="2w8y6eurej9dq" />
                            </button>
                          </li>)}
                      </ul>
                    </div>}
                </>}
            </div>
          </motion.aside>
        </>}
    </AnimatePresence>;
}